import React from "react";
import { Image } from "Components/atoms/Image";
import { IconWrapper, StyledButton } from "./styles";
import { ButtonProps } from "./types";

/**
 * Componente Button
 *
 * Um botão altamente personalizável que pode conter texto, ícones ou imagens.
 *
 * @param {string} label - Texto exibido no botão.
 * @param {keyof typeof theme.colors.font} [color='white'] - Cor do texto.
 * @param {keyof typeof theme.colors.primary} [backgroundColor='lightBlue'] - Cor de fundo do botão.
 * @param {'small' | 'medium' | 'large' | 'ghost'} [size='medium'] - Tamanho do botão.
 * @param {boolean} [rounded=false] - Define se o botão terá bordas arredondadas.
 * @param {boolean} [uppercase=false] - Define se o texto será transformado em letras maiúsculas.
 * @param {React.ReactNode} icon - Ícone exibido dentro do botão.
 * @param {StaticImageData} image - Imagem exibida dentro do botão.
 * @param {() => void} onClick - Função executada ao clicar no botão.
 */
export const Button: React.FC<ButtonProps> = ({
  label,
  icon,
  onClick,
  ...props
}) => {
  const {
    backgroundColor,
    color,
    size,
    rounded,
    fontWeight,
    primary,
    image,
    uppercase = false,
    ...rest
  } = props;

  return (
    <StyledButton
      backgroundColor={backgroundColor}
      color={color}
      size={size}
      rounded={rounded}
      primary={primary}
      fontWeight={fontWeight}
      uppercase={uppercase}
      onClick={onClick}
      {...rest}
    >
      {icon && <IconWrapper size="large">{icon}</IconWrapper>}
      {label && label}
      {image && <Image src={image} alt="" />}
    </StyledButton>
  );
};
